angular
  .module("admin")
  .component("customerCard", {
    templateUrl: "views/components/customerCard.html",
    bindings: {
      customer: "=",
      edit: "&",
      changeAdmin: "&",
      deleteCustomer: "&",
    },
    controller: function (
      SupervisorResource,
      AdminCustomersResource,
      $uibModal,
      RemovalReasons
    ) {
      this.getRemovalReasonLabel = function (reason) {
        if (!reason) return null;
        return RemovalReasons.getLabel(reason);
      };
      this.impersonate = function (customer) {
        SupervisorResource.impersonate(
          {
            userId: customer.id,
          },
          (session) => {
            $uibModal.open({
              component: "impersonateModal",
              resolve: {
                session: session,
              },
            });
          }
        );
      };
      this.takedown = function (customer) {
        AdminCustomersResource.takedown(
          {
            id: customer.id,
          },
          () => {
            alert("Sessão derrubada!");
          }
        );
      };
      this.handleChangeAdmin = function (customer) {
        if (this.changeAdmin) {
          this.changeAdmin({ u: customer });
        }
      };
    },
  })
  .component("changeAdminModal", {
    templateUrl: "views/subscriptions/change_admin.html",
    controller: function (SubscriptionDetailsResource) {
      this.changeAdmin = function () {
        SubscriptionDetailsResource.changeAdmin(
          {
            subscriptionNumber: Number(this.resolve.subscriptionNumber),
            administratorId: this.resolve.customer.id,
          },
          () => {
            this.close();
          },
          (err) => (this.error = err.data.message)
        );
      };
    },
    bindings: {
      resolve: "<",
      dismiss: "&",
      close: "&",
    },
  })

  .component("impersonateModal", {
    bindings: {
      close: "&",
      resolve: "<",
    },
    controllerAs: "ctrl",
    controller: function (config) {
      this.site = config.site;

      this.access = function () {
        const session = this.resolve.session;
        const params = [];

        if (session.data.accessToken) {
          params.push(
            "accessToken=" + encodeURIComponent(session.data.accessToken)
          );
        }
        if (session.data.idToken) {
          params.push("idToken=" + encodeURIComponent(session.data.idToken));
        }
        if (session.data.refreshToken) {
          params.push(
            "refreshToken=" + encodeURIComponent(session.data.refreshToken)
          );
        }

        const url = this.site + "/impersonate?" + params.join("&");
        window.open(url, "_blank");
      };
    },
    templateUrl: "views/components/impersonate.html",
  })
  .component("organizationDetails", {
    bindings: {
      organization: "=",
      invoiceAddress: "=",
      invoiceRecipients: "=",
    },
    templateUrl: "views/components/organizationDetails.html",
    controller: function ($uibModal, config, CnpjUtils) {
      this.config = config;
      this.formatCnpj = function (cnpj) {
        return CnpjUtils.format(cnpj);
      };
      this.editOrganization = function () {
        $uibModal.open({
          controller: "EditOrganizationCtrl",
          controllerAs: "$ctrl",
          templateUrl: "views/subscriptions/edit-organization.html",
          resolve: {
            organization: () => this.organization,
          },
        });
      };
    },
  })
  .component("faBoolean", {
    bindings: {
      value: "=",
    },
    controller: function ($scope) {
      this.$onInit = function () {
        if (this.value) {
          this.text = "Sim";
          this.cls = "fa-boolean-yes";
          this.icon = "fa-check";
        } else {
          this.text = "Não";
          this.cls = "fa-boolean-no";
          this.icon = "fa-times";
        }
      };
    },
    transclude: true,
    template: `<span class="fa-boolean" ng-class="$ctrl.cls">
        <i class="fa" ng-class="$ctrl.icon"></i> {{$ctrl.text}}
    </span>`,
  })
  .component("email", {
    bindings: {
      to: "<",
    },
    template: `   <a href="mailto:{{$ctrl.to}}">
                <i class="fa fa-envelope-o"></i>
                {{$ctrl.to}}
            </a>`,
  })
  .component("phoneNumber", {
    bindings: {
      phone: "=",
    },
    template: `
    <span ng-if="$ctrl.phone"><i class="fa fa-phone"></i>

    <span ng-if="$ctrl.phone.ddd">
    {{($ctrl.phone.ddd + '' + $ctrl.phone.number) | brPhoneNumber}}
    </span>
    <span ng-if="!$ctrl.phone.ddd">
    {{$ctrl.phone | brPhoneNumber}}
    </span>
    </span>
  `,
  })
  .component("address", {
    bindings: {
      address: "=",
    },
    template: `
    <span ng-if="$ctrl.address">
    {{$ctrl.address.street}} <span ng-if="$ctrl.address.number">, {{$ctrl.address.number}}</span> {{$ctrl.address.complement}}
    <br />{{$ctrl.address.neighborhood}} - {{$ctrl.formatCep($ctrl.address.postalCode)}}
    <br />{{$ctrl.address.city}} - {{$ctrl.address.state}}
    </span>
    `,
    controller: function () {
      this.formatCep = function (cep) {
        if (!cep) return "";
    
        const digits = String(cep).replace(/\D/g, "").padStart(8, "0");
        if (digits.length !== 8) return cep;
    
        return `${digits.slice(0, 5)}-${digits.slice(5)}`;
      };
    },
  })
  .component("monthNav", {
    bindings: {
      onChange: "&",
      current: "=",
    },
    template: `
     <div class="month-picker">
                <a href ng-click="$ctrl.backwards()" class="btn btn-link"><i class="fa fa-chevron-left"></i></a>
                <span class="month">{{$ctrl.current | date:'MMMM/yyyy'}}</span>

                <a ng-click="$ctrl.towards()" href class="btn btn-link"><i class="fa fa-chevron-right"></i></a>
            </div>
    `,
    controller: function () {
      this.current = new Date();

      this.towards = function () {
        this.current.setMonth(this.current.getMonth() + 1);
        this.onChange(this.current);
      };
      this.backwards = function () {
        this.current.setMonth(this.current.getMonth() - 1);
        this.onChange(this.current);
      };
    },
  })
  .component("resultsCount", {
    bindings: {
      count: "=",
    },
    template: `
        {{$ctrl.count}}
                <span ng-if="$ctrl.count === 1">
                    resultado encontrado
                </span>
                <span ng-if="$ctrl.count > 1">
                resultados encontrados
                </span>
        `,
  });
